import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ReactLoading from 'react-loading';
import MetaTags from 'react-meta-tags';
import '../css/AssesmentTest.css'

export default class AssessmentTest extends Component {
  constructor() {
    super();
    this.state = {
      loading: true
    }
  }
  componentDidMount() {
    window.scrollTo(0,0);
    setTimeout(() => this.setState({ loading: false }), 1500);
  }
  render() {
    const { loading } = this.state;
    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    return(
      <div className="container hasPadding">
       <div className="row">
       <MetaTags>
            <title>草學藥事 || 體質分析檢測</title>
            <meta id="og-title" property="og:title" content="體質分析檢測" />
        </MetaTags>
        <div className="col-xs-12 col-sm12 col-md-12 col-lg-12">
        <div>
        <article className="textCenter atBox">
         <h1>體質分析檢測</h1>
         <h2>發現身體疾病,開始自我檢測</h2>
        </article>
         <Tabs>
          <TabList>
           <Tab>一般體質測驗</Tab>
           <Tab>中醫體質測驗</Tab>
          </TabList>
          <TabPanel>

            <article className="AssessmentTestList">
             <Link to="/Table1" className="allTable1">
              <div className="tab1hover"></div>
              <div style={Jeyu.Table1} className="thumbimg1"></div>
              <p>亞健康自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table2" className="allTable2">
              <div className="tab2hover"></div>
              <div style={Jeyu.Table1} className="thumbimg2"></div>
              <p>過勞自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table3" className="allTable3">
              <div className="tab3hover"></div>
              <div style={Jeyu.Table1} className="thumbimg3"></div>
              <p>自我肯定診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table4" className="allTable4">
             <div className="tab4hover"></div>
              <div style={Jeyu.Table1} className="thumbimg4"></div>
              <p>失眠自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table5" className="allTable5">
             <div className="tab5hover"></div>
              <div style={Jeyu.Table1} className="thumbimg5"></div>
              <p>壓力自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table6" className="allTable6">
             <div className="tab6hover"></div>
              <div style={Jeyu.Table1} className="thumbimg6"></div>
              <p>憂鬱自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table7" className="allTable7">
             <div className="tab7hover"></div>
              <div style={Jeyu.Table1} className="thumbimg7"></div>
              <p>尼古丁成癮度診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table8" className="allTable8">
             <div className="tab8hover"></div>
              <div style={Jeyu.Table1} className="thumbimg8"></div>
              <p>趴趴熊自我診斷</p>
             </Link>
            </article>
            <article className="AssessmentTestList">
             <Link to="/Table9" className="allTable9">
             <div className="tab9hover"></div>
              <div style={Jeyu.Table1} className="thumbimg9"></div>
              <p>飲食行為自我診斷</p>
             </Link>
            </article>

          </TabPanel>
          <TabPanel>

          <article className="AssessmentTestList">
           <Link to="/CMTable1" className="allcmTable1">
           <div className="cmtab1hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg1"></div>
            <p>平和質(A型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable2" className="allcmTable2">
           <div className="cmtab2hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg2"></div>
            <p>氣虛質(B型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable3" className="allcmTable3">
           <div className="cmtab3hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg3"></div>
            <p>陽虛質(C型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable4" className="allcmTable4">
           <div className="cmtab4hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg4"></div>
            <p>陰虛質(D型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable5" className="allcmTable5">
           <div className="cmtab5hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg5"></div>
            <p>痰濕質(E型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable6" className="allcmTable6">
           <div className="cmtab6hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg6"></div>
            <p>濕熱質(F型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable7" className="allcmTable7">
           <div className="cmtab7hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg7"></div>
            <p>血瘀質(G型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable8" className="allcmTable8">
           <div className="cmtab8hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg8"></div>
            <p>氣鬱質(H型)</p>
           </Link>
          </article>
          <article className="AssessmentTestList">
           <Link to="/CMTable9" className="allcmTable9">
           <div className="cmtab9hover"></div>
            <div style={Jeyu.Table1} className="cmthumbimg9"></div>
            <p>特稟質(I型)</p>
           </Link>
          </article>

          </TabPanel>
         </Tabs>

         </div>
        </div>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  Table1: {
    height: 300,
    textAlign: 'center',
    width: 300,
    overflow: 'hidden'
  },
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  }
}



// WEBPACK FOOTER //
// ./src/View/AssessmentTest.js